module.exports = "<div class=\"sidebar\">\n  <app-sidebar-header></app-sidebar-header>\n  <app-sidebar-form></app-sidebar-form>\n  <nav class=\"sidebar-nav\">\n    <ul class=\"nav\">\n\n      <li class=\"nav-title\">\n      </li>\n\n\n    </ul>\n  </nav>\n  <app-sidebar-footer></app-sidebar-footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-sidebar/app-sidebar.component.html
// module id = ./src/app/components/app-sidebar/app-sidebar.component.html
// module chunks = main